'use client'
import * as React from 'react'

export const ScrollResetOnReload = () => {
  // Disable browser auto scroll restoration
  React.useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  // Force scroll to top on mount
  React.useLayoutEffect(() => {
    // initial sync reset
    window.scrollTo(0, 0)

    // hedge against late layout / virtualizer changes
    requestAnimationFrame(() => {
      window.scrollTo(0, 0)
    })
  }, [])

  return null
}
